import React, { useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import FileUploadInput from "components/FileUploadInput";
import { isBlank, notBlank } from "../../util/ext";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, DialogContentText, DialogTitle } from "@material-ui/core";
import { useErrorBox } from "./use-errorBox";
import { useUploadOrganizationLogo } from "../organizationServices";
import PhotoOutlinedIcon from "@material-ui/icons/PhotoOutlined";

const OrganizationLogoDialog = ({
  organizationId,
  organizationLogoUrl,
  onCancel,
  onSave,
  open,
}) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const onFileInputChange = file => {
    setLogoFile(file);
    if (notBlank(file)) {
      const reader = new FileReader();
      reader.onload = () => {
        const dataUrl = reader.result;
        setLogoUrl(dataUrl);
      };
      reader.readAsDataURL(file);
      removeValidationError("logoFile");
    } else {
      setLogoUrl(null);
    }
  };

  const {
    setGeneralError,
    addValidationError,
    firstValidationError,
    removeValidationError,
    ErrorBox: DialogErrors,
  } = useErrorBox();

  const logoUpload = useUploadOrganizationLogo();
  const handleApply = async () => {
    if (notBlank(logoFile)) {
      setUploading(true);
      try {
        await logoUpload.mutateAsync({
          resourceIds: { id: organizationId },
          data: logoFile,
        });
        onSave({ logoUrl, logoFile });
      } catch (err) {
        setGeneralError(err);
      } finally {
        setUploading(false);
      }
    } else {
      addValidationError({ logoFile: ["An image must be selected"] });
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle id="edit-organization-logo-dialog-title">
        Organization Logo
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          Choose the image you wish to upload. This image should be a PNG with a
          size of 250px x 120px.
        </DialogContentText>
        <DialogErrors />

        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          maxWidth={600}
        >
          <Box
            margin={2}
            minWidth={250}
            minHeight={150}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {uploading ? (
              <CircularProgress />
            ) : isBlank(organizationLogoUrl) && isBlank(logoUrl) ? (
              <PhotoOutlinedIcon style={{ fontSize: 60 }} />
            ) : (
              <img
                style={{ maxWidth: 250, maxHeight: 150 }}
                src={logoUrl || organizationLogoUrl}
                alt="Logo"
              />
            )}
          </Box>

          <Box flexGrow={1} margin={2} width={250}>
            <FileUploadInput
              value={logoFile}
              accept=".png, image/png"
              onChange={onFileInputChange}
              disabled={uploading}
              error={firstValidationError("logoFile")}
            />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button disabled={uploading} onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button disabled={uploading} onClick={handleApply} color="primary">
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OrganizationLogoDialog;
